import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { PlatformUtils_getInstanceitqdjrwn2jrm as PlatformUtils_getInstance } from '../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function installPlugin($this, plugin) {
  if ($this.j5h_1.x4(plugin.r3()))
    return Unit_instance;
  var tmp0 = $this.j5h_1;
  var tmp2 = plugin.r3();
  // Inline function 'kotlin.collections.set' call
  var value = (scope) => {
    var tmp = get_PLUGIN_INSTALLED_LIST();
    var attributes = scope.g5g_1.c4n(tmp, HttpClientConfig$installPlugin$lambda$lambda);
    var config = ensureNotNull(scope.j5g_1.k5h_1.z4(plugin.r3()));
    var pluginData = plugin.c5i(config);
    plugin.d5i(pluginData, scope);
    attributes.z4m(plugin.r3(), pluginData);
    return Unit_instance;
  };
  tmp0.c5(tmp2, value);
}
function HttpClientConfig$engineConfig$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$install$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$installPlugin$lambda$lambda() {
  return AttributesJsFn(true);
}
var HttpClientConfigClass;
function HttpClientConfig() {
  if (HttpClientConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.j5h_1 = LinkedHashMap().gc();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.k5h_1 = LinkedHashMap().gc();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_1.l5h_1 = LinkedHashMap().gc();
        var tmp_2 = this;
        tmp_2.m5h_1 = HttpClientConfig$engineConfig$lambda;
        this.n5h_1 = true;
        this.o5h_1 = true;
        this.p5h_1 = false;
        this.q5h_1 = PlatformUtils_getInstance().h4o_1;
      }
      e5i(plugin, configure) {
        var previousConfigBlock = this.k5h_1.z4(plugin.r3());
        var tmp0 = this.k5h_1;
        var tmp2 = plugin.r3();
        // Inline function 'kotlin.collections.set' call
        var value = (_this__u8e3s4) => {
          var tmp0_safe_receiver = previousConfigBlock;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          configure(!(_this__u8e3s4 == null) ? _this__u8e3s4 : THROW_CCE());
          return Unit_instance;
        };
        tmp0.c5(tmp2, value);
        installPlugin(this, plugin);
      }
      r5h(plugin, configure, $super) {
        var tmp;
        if (configure === VOID) {
          tmp = HttpClientConfig$install$lambda;
        } else {
          tmp = configure;
        }
        configure = tmp;
        var tmp_0;
        if ($super === VOID) {
          this.e5i(plugin, configure);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $super.e5i.call(this, plugin, configure);
        }
        return tmp_0;
      }
      s5h(key, block) {
        // Inline function 'kotlin.collections.set' call
        this.l5h_1.c5(key, block);
      }
      d5h(client) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.j5h_1.b5().u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          // Inline function 'kotlin.apply' call
          element(client);
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = this.l5h_1.b5().u1();
        while (_iterator__ex2g4s_0.v1()) {
          var element_0 = _iterator__ex2g4s_0.w1();
          // Inline function 'kotlin.apply' call
          element_0(client);
        }
      }
      t5h(other) {
        this.n5h_1 = other.n5h_1;
        this.o5h_1 = other.o5h_1;
        this.p5h_1 = other.p5h_1;
        var tmp0 = this.j5h_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map = other.j5h_1;
        tmp0.e5(map);
        var tmp0_0 = this.k5h_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_0 = other.k5h_1;
        tmp0_0.e5(map_0);
        var tmp0_1 = this.l5h_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_1 = other.l5h_1;
        tmp0_1.e5(map_1);
      }
    }
    initMetadataForClass($, 'HttpClientConfig', HttpClientConfig);
    HttpClientConfigClass = $;
  }
  return HttpClientConfigClass;
}
//region block: exports
export {
  HttpClientConfig as HttpClientConfigo6p492ed655g,
};
//endregion

//# sourceMappingURL=HttpClientConfig.mjs.map
